import { useSendPasswordResetEmail } from "react-firebase-hooks/auth";
import { toast, ToastContainer } from "react-toastify";
import FirebaseError from "../components/FirebaseError";
import SpinnerBorder from "../components/SpinnerBorder";
import auth from "../firebase/auth";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

export default function LoginForm({
  signInWithEmailAndPassword,
  signingInWithEmailAndPassword,
  emailAndPasswordSignInError,
}) {
  const [sendPasswordResetEmail, , passwordResetError] =
    useSendPasswordResetEmail(auth);

  const handleLogin = (event) => {
    event.preventDefault();

    const { email, password } = Object.fromEntries(
      new FormData(event.target).entries()
    );

    signInWithEmailAndPassword(email, password);
  };

  const handleForgotPassword = async (event) => {
    const form = event.target.closest("form");

    const emailAddress = form.email.value;

    await sendPasswordResetEmail(emailAddress);

    toast.success("Password Rest Email Sent");
  };

  return (
    <>
      <ToastContainer />

      <h1 class="text-5xl font-bold mb-6">Login now!</h1>

      <div class="card flex-shrink-0 w-full max-w-sm mx-auto shadow-2xl bg-base-100">
        <form onSubmit={handleLogin} class="card-body">
          <div class="form-control">
            <label class="label">
              <span class="label-text">Email</span>
            </label>

            <input
              type="text"
              name="email"
              placeholder="email"
              class="input input-bordered"
              required
            />
          </div>

          <div class="form-control">
            <label class="label">
              <span class="label-text">Password</span>
            </label>

            <input
              type="password"
              name="password"
              placeholder="password"
              class="input input-bordered"
              autoComplete="current-password"
              required
            />

            <label class="label">
              <button
                onClick={handleForgotPassword}
                class="mt-1 label-text-alt link link-hover hover:text-blue-500"
              >
                Forgot password?
              </button>
            </label>
          </div>

          <div class="form-control">
            <label class="label">
              <Link
                to="/register"
                class="label-text-alt link link-hover hover:!text-blue-500"
              >
                Don't have an account?
              </Link>
            </label>

            <button type="submit" class="btn btn-primary">
              {signingInWithEmailAndPassword ? <SpinnerBorder /> : <>Login</>}
            </button>

            {(emailAndPasswordSignInError || passwordResetError) && (
              <FirebaseError
                error={emailAndPasswordSignInError || passwordResetError}
              />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
